import { faculty } from "../../constants/apiUrl";
import { IApiResponse } from "../../models/IAPIResponse";
import APIService from "../../helper/api-service";
import { IFacultyClassesDetails, IFacultyConnectDetails } from "../../models/faculty/facultyConnect";
import { urlBinder } from "../../helper/url-binder";

export default new (class FacultyConnectService {
  public getFacultyConnectDetails = async (
    id: number
  ): Promise<IApiResponse<Array<IFacultyConnectDetails>>> => {
    try {
      let endPoint = urlBinder(faculty.GET_FACULTY_CONNECT, [`${id}`])
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<Array<IFacultyConnectDetails>>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<Array<IFacultyConnectDetails>>;
      } else {
        throw error;
      }
    }
  };

  public getFacultyClassDetails = async (
  ): Promise<IApiResponse<Array<IFacultyClassesDetails>>> => {
    try {
      let endPoint = faculty.GET_FACULTY_CONNECT_CLASS
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<Array<IFacultyClassesDetails>>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<Array<IFacultyClassesDetails>>;
      } else {
        throw error;
      }
    }
  };
})();
